export default __webpack_public_path__ + "static/media/icon-arrow-side-color-gray.c0f48b58.svg";